<script setup>
import {useReportOutput} from "@/components/report/outputs/useReportOutput";

const props = defineProps({
    value: null
  })

const {v, extra} = useReportOutput(props)

</script>

<template>
  <b-link v-if="!$store.state.printing && extra?.report_id" @click="$router.push({name: 'report-run', params: {id: extra.report_id}, query: extra.params})">{{ v }}</b-link>
  <div v-else>{{ v }}</div>
</template>

<style scoped>

</style>